export const getCellRangeForPaste = (startPosition, clipboardData, columns) => {
  let [columnEnd] = columns
    .slice(columns.findIndex((c) => c.colId === startPosition.col))
    .filter((c) => c.visible)
    .slice(0, getClipboardWidth(clipboardData))
    .map((c) => c.colId)
    .slice(-1);

  if (!(columnEnd?.length > 0)) {
    columnEnd = columns[columns.length - 1].colId;
  }

  return {
    rowStartIndex: startPosition.rowIndex,
    rowEndIndex: startPosition.rowIndex + clipboardData.length - 1,
    columnStart: startPosition.col,
    columnEnd: columnEnd,
  };
};

export const getClipboardWidth = (clipboardData) => {
  return clipboardData
    .map((e) => e.length)
    .reduce((p, c) => {
      return p > c ? p : c;
    });
};
